import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-not-found',
	imports: [SharedModule, ButtonComponent],
	templateUrl: './not-found.component.html',
	styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
	constructor(
		private router: Router,
		private authService: AuthService,
	) {}

	handleGoBack(): void {
		if (this.authService.isAuthenticated()) {
			this.router.navigate(['/']);
		} else {
			this.router.navigate(['/']);
		}
	}
}
